export default {
  success: "Success",
  error: "Error",
  warning: "Warning",
  info: "Info",
  usernameOrPasswordIsWrong: "Username Or Password Is Wrong",
  errorOccurred: "An Error Occurred",
  successAction: "Success Action",
  failedAction: "Failed Action",
  submissionSucceed: "Submission Succeed",
  editionSucceed: " Edition Succeed",
  submissionFailed: "Submission Failed",
  editionFailed: " Edition Failed",
  deletionSucceed: "Delete Successfully Done.",
  deletionFailed: "Delete Failed.",
  duplicatedData: "Some Data Are Duplicated!",
  notFound: "Page Not Found!",
  badRequestTitle: "Bad Request!",
  badRequest: "Some Data Are Invalid",
  genderNotDetect: "User Gender Not Detected.",
  spouseNotRegistered: "Spouse Info Not Registered!",
  userNotFound: "user Not Found",
  amountIsMoreThanPayable: "Amount Is More Than Payable",
  patientAge: "Patient's age is not allowed to reception",
  patientGender: "Men are not allowed to reception",
  patientMaritalStatus: "Single patient is not allowed to reception",
  noMedicalRecord: "No Medical Record",
  notRealizationOfMarriage: "Not Realization Of Marriage!",
  todayVisitStatus: "You Can,t Visit Again For Today!",
  sameServiceSameDr: "Cannot Sumbit Same Service With The Same Dr",
  invalidDateInterval: "The Start Date Is Larger Than The End Date.",
  invalidDate: "The Date Is Not Valid.",
  areYouSureOfDeletion: "Are You Sure About Delete this Item :  {item} ?",
  fillInAtLeastOneField: "Fill in at least one field",
  noUserFoundForThisFile: "No User Found For This File",
  medicalRecordNotFound: "Medical Record Not Found",
  isSingle: "Is Single",
  marriageDateNotEntered: "Marriage Date Not Entered",
  noReferenceReason: "Reference Reason Not Exist!",
  fileNotSelected: "File Not Selected!",
  selectAtLeastOneItem: "Please Select At Least One Item ",
  dateNotSelected: "Date Not Selected",
  noDataAvailable: "No Data Available",
  sorryNoMatchingOptions: "Sorry, No Matching Options",
  referencesAlert: "You Have {count} UnRead Reference Reason",
  legalRejected:
    "Patient legal status is denied. Please refer to legal record ",
  legalConditioned:
    "Patient legal status is conditioned. Please refer to legal record",
  legalRejectAndConditioned:
    "Patient legal status is denied/conditioned. Please refer to legal record ",
  itemsRequired: "This Items Are Require: {items} ",
  fillTheSpouseInfo: "Fill The The Spouse Info For Infertility Referral",
  fileUploadFailed: "File Upload Failed",
  isComeNotDelete:
    "It is not possible to delete the reservation in the referred state",
  multipleOfFive: "The time interval must be a multiple of 5",
  changeLangToEn: "Please change the keyboard language to English",
  MandatoryUnit:"Unit selection is required",
  Interval:"The time interval must be a multiple of 5",
  ErrFromTime:'Start time is required!',
  ErrEndTime:'End time is required!',
  ErrMaxTurn: 'Enter the number of patients per turn!'
}
